import React from "react";
import StyledMdText from "../../common/components/styledMdText/StyledMdText";

// Files Import

const Copyrights = () => {
  const currentYear = new Date().getFullYear();
  return (
    <StyledMdText font="text-white text-center">
      Jaba the pepe {currentYear} &#169; ALL RIGHTS RESERVED
    </StyledMdText>
  );
};

export default Copyrights;
